import { Address, CompanyAddress } from './Address'

export class Company {
	public _id: string
	public social_name: string
	public cnpj: string
	public address: CompanyAddress
	public email: string
	public telephone: string
	public cellphone: string
	public facebook: string
	public instagram: string
	public twitter: string
	public responsible_name: string
	public responsible_telephone: string
	public responsible_ramal: string
	public enableDesktopAccess: boolean
	public enableAutomaticDemandConfirmationEmail: boolean
	public enabledCloneInventory: boolean
	public demandRadiusDelimiter: number
	public nonScheduledOperation: boolean
	public license_type: string
	public qtd_admins: number
	public qtd_evaluators: number
	public qtd_operators: number
	public qtd_inventors: number
	public qtd_adminsUsed: number
	public qtd_evaluatorsUsed: number
	public qtd_operatorsUsed: number
	public qtd_inventorsUsed: number
	public isArcgis: boolean
	public signature_date: Date
	public validity: Date
	public contract: string
	public contract_media: string
	public status: string
	public ie: string
	public ramal: string
	public site: string
	public comments: string
	public identifierName: string
	public responsible_email: string
	public responsible_cellphone: string
	public manualTreeIdentification: boolean
	public manualTreeIdentificationInventory: boolean
	public mandatoryIdentificationInventory: boolean
	public mandatoryGoogleMaps: boolean
	public mandatoryArcGisApps: boolean
	public mandatoryArcGis: boolean
	public mandatoryIdentification: boolean
	public non_scheduleEvaluation: boolean
	public enableNotifications: boolean
	public enableLegalFundamentation: boolean
	public enableRealTime: boolean
	public mediaCompany: string
	public mediaPublicBody: string
	public enablePlantingOpportunity: boolean
	public appSolicitante: boolean
	public publicPanel: boolean
	public enabledBackup: boolean
	public subdomain?: string
	public modules: Array<{ id: number, companyModuleId: number, name: string, active: boolean }>

	constructor() {
		this.enabledBackup = false
		this.mandatoryIdentification = false
		this.mandatoryIdentificationInventory = false
		this.manualTreeIdentification = false
		this.mandatoryArcGis = false
		this.mandatoryArcGisApps = false
		this.manualTreeIdentificationInventory = false
		this.non_scheduleEvaluation = false
		this.nonScheduledOperation = false
		this.isArcgis = false
		this.appSolicitante = false
	}
}

export interface ICompanyRole {
	value: string
	name: string
	selectable: boolean
	disabled: boolean
}
